module.exports = __webpack_public_path__ + "static/media/afericao-vital-icon.19f6e5bb.svg";